export enum UIRegistrationSteps {
	INSERT_TOKEN = 'token',
	INSERT_ACCOUNT_DATA = 'accountData',
	INSERT_USER_DATA = 'userData',
	INSERT_PLAN = 'plan',
	REGISTRATION_FINISHED = 'finished'
}
